import { CSSProperties } from 'react'

export const s = {
  info: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'start',
  } as CSSProperties,
  tag: {
    padding: '4px 8px',
    marginRight: 8,
    marginTop: 8,
    color: '#262626',
    fontSize: '14px',
  },
  enquiryCard: { margin: 8, width: '100%', maxWidth: 1262 },
  detailsText: { marginLeft: 4, fontSize: '16px', color: '#1270B8' },
  timings: { fontWeight: 500, fontSize: '14px', color: '#262626' },
}
